document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        let selectName = document.querySelectorAll('.offers-job__code .skk_filters select');
        selectName.forEach((e) => {
            e.removeAttribute('multiple');
            e.removeAttribute('size');
        })

        const labelRegion = document.querySelector('.skk_filters label[for="r"]');
        const labelWorkPlace = document.querySelector('.skk_filters label[for="wp"]');
        const labelKeyWords = document.querySelector('.skk_filters label[for="kw"]');
        const requiredAsteriks = document.createElement('span');
        requiredAsteriks.style.color = "#C43C2B";
        requiredAsteriks.innerText = "*";

        if(null!==labelRegion){
            labelRegion.appendChild(requiredAsteriks.cloneNode(true));
        }

        if(null !== labelWorkPlace) {
            labelWorkPlace.appendChild(requiredAsteriks.cloneNode(true));
        }

        if(null !== labelKeyWords) {
            labelKeyWords.appendChild(requiredAsteriks.cloneNode(true));
        }

        const queryParamsString = window.location.search.substring(1);

        const queryParams = queryParamsString.split('&').reduce((accumulator, singleQueryParam) => {
            const [key, value] = singleQueryParam.split('=');
            accumulator[key] = decodeURIComponent(value);
            return accumulator;
        }, {});
        const btnSubmit = document.querySelector('.skk_filters_btn_search');

        if (btnSubmit !== undefined && btnSubmit !== null) {
            if (queryParams.kw !== undefined) {
                const keyWord = document.querySelector('.skk_filters_txt_kw');
                keyWord.value = queryParams.kw;
            }

            if (queryParams.rg !== undefined) {
                const regions = document.querySelector('#lstAvailableRegions');
                const options = regions.querySelectorAll('option');
                // console.log(options);
                options.forEach(option => {
                    if (option.textContent == queryParams.rg) {
                        option.setAttribute('selected', '');
                    }
                })
            }
            btnSubmit.click();
        }
    }, 900);

});
